function getRollupIsAnyFilters(isPermissionFilter) {
	let filters = [
		{ id: 'item-rollups-and-descendants', key: 'datasets.rollupFilters.itemAndDescendants' },
		{ id: 'item-rollups-children-and-grandchildren', key: 'datasets.rollupFilters.itemChildrenAndGrandchildren' },
		{ id: 'item-rollups-and-children', key: 'datasets.rollupFilters.itemAndChildren' },
		{ id: 'item-only', key: 'datasets.rollupFilters.itemOnly' }
	]
	if (isPermissionFilter) {
		filters = [
			{ id: 'item-rollups-and-descendants', key: 'datasets.rollupPermissions.itemRollupsAndDescendants' },
			{ id: 'item-rollups-children-and-grandchildren', key: 'datasets.rollupPermissions.itemRollupsChildrenAndGrandchildren' },
			{ id: 'item-rollups-and-children', key: 'datasets.rollupPermissions.itemRollupsAndChildren' },
			{ id: 'item-and-rollups', key: 'datasets.rollupPermissions.itemAndRollups' },
			{ id: 'rollups-only', key: 'datasets.rollupPermissions.rollupsOnly' },
			{ id: 'item-only', key: 'datasets.rollupPermissions.itemOnly' }
		]
	}
	return filters
}

export default getRollupIsAnyFilters
getRollupIsAnyFilters.__filename__ = 'datasets/filters/get-rollup-is-any-filters.js'
